module.exports = __webpack_public_path__ + "static/media/ptsans-regular.696431ac.woff";